import * as React from "react";
import { UitkFigure, UitkImage } from "uitk-react-images";
import LazyLoad from "react-lazyload";

import { ImageViewModel } from "./UitkGalleryCarousel";
import { AttributionText } from "components/shared/AttributionText/AttributionText";
import { LazyLoaderPlaceHolder } from "components/utility/LazyLoaderPlaceholderWrapper";

interface UitkGalleryCarouselItemProps extends ImageViewModel {
  ariaHidden?: boolean;
  className?: string;
  index: number;
}

export class UitkGalleryCarouselItem extends React.PureComponent<UitkGalleryCarouselItemProps> {
  public static displayName = "UitkGalleryCarouselItem";
  public static defaultProps = { ariaHidden: false };

  public render() {
    const { className, alt, src, caption } = this.props;

    return (
      <div className={`uitk-gallery-carousel-item uitk-cell ${className}`}>
        <UitkFigure key={src} className="all-image-fit-cover">
          <LazyLoad
            offset={1500}
            once={true}
            placeholder={<LazyLoaderPlaceHolder name={caption} />}
          >
            <UitkImage alt={alt} src={src} placeholderImage={true} />
          </LazyLoad>
          {this.props.source && (
            <AttributionText
              source={this.props.source}
              origin={this.props.origin}
              attribUrl={this.props.attribUrl}
              authorName={this.props.authorName}
              authorUrl={this.props.authorUrl}
              licenseSuite={this.props.licenseSuite}
              licenseName={this.props.licenseName}
              licenseUrl={this.props.licenseUrl}
            />
          )}
        </UitkFigure>
      </div>
    );
  }
}
